import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { motion } from "framer-motion";

export default function ContactSection() {

    const contactMethods = [
        {
          icon: <FaMapMarkerAlt className="icon" />, 
          label: "Marikina City",
          title: "Find Us",
          href:'https://maps.app.goo.gl/P3NV1VUYavaja7qg8',
          target:'_blank'
        },
        {
          icon: <FaPhoneAlt className="icon" />, 
          label: "(02) 8656 7856",
          title: "Call Us",
          href: "tel:0286567856",
          target:'_blank'
        },
        {
          icon: <FaEnvelope className="icon" />, 
          label: "info@proslv.com.ph",
          title: "Email",
          href: "/contact",
          target:"_self"
        },
        {
          icon: <FaFacebookF className="icon" />, 
          label: "@PROSLV",
          title: "Facebook",
          href: "https://www.facebook.com/profile.php?id=100009751877436",
          target:'_blank'
        },
        // {
        //   icon: <FaInstagram className="icon" />,
        //   label: "@PROSLV",
        //   title: "Instagram",
        //   href: "https://instagram.com/proslv",
        //   target:'_blank'
        // },
        {
          icon: <FaLinkedinIn className="icon" />, 
          label: "@PROSLV",
          title: "LinkedIn",
          href: "https://www.linkedin.com/in/larry-zuniega-4060b4102",
          target:'_blank'
        }
      ];

    return (
      <>
        <div className="heading-frame">
                        <div className="border-frame tr"></div>

                        <h2 className="text-center heading">Contact Us </h2>

                        <div className="border-frame bl"></div>
                      </div>
        <div className="grid">
          {contactMethods.map((method, index) => (
            <motion.div
              key={index}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <a href={method.href || "#"} target={method.target} rel="noopener noreferrer">
                <div className="card">
                  <div className="card-content">
                    <div className="icon-wrapper">{method.icon}</div>
                    <h3 className="card-title">{method.title}</h3>
                    <p className="card-label">{method.label}</p>
                  </div>
                </div>
              </a>
            </motion.div>
          ))}
        </div>
      </>
    );
  }